import { hookstate } from '@hookstate/core'
import { Notification } from '../../domain/entities'

export type NotificationsState = {
  messages: Notification[]
}

const initialState: NotificationsState = {
  messages: []
}

const NotificationsGlobalState = hookstate(initialState)

export { NotificationsGlobalState }
